import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromVehicleFilters from '../reducers/vehicle-filters.reducer';

export const selectVehicleFiltersState =
  createFeatureSelector<fromVehicleFilters.State>(
    fromVehicleFilters.vehicleFiltersFeatureKey,
  );

export const getVehicleFilters = createSelector(
  selectVehicleFiltersState,
  fromVehicleFilters.getVehicleFilters,
);

export const getSelectedFilters = createSelector(
  selectVehicleFiltersState,
  fromVehicleFilters.getSelectedFilters,
);

export const getVehicleSortBy = createSelector(
  selectVehicleFiltersState,
  fromVehicleFilters.getSortBy,
);
export const getSearchText = createSelector(
  selectVehicleFiltersState,
  fromVehicleFilters.getSearchText,
);
export const getVehicleSortByList = createSelector(
  selectVehicleFiltersState,
  fromVehicleFilters.getSortByList,
);
export const getSearchFields = createSelector(
  selectVehicleFiltersState,
  fromVehicleFilters.getSearchFields,
);
